<template>
  <div class="organisation-list container">
    <div v-if="isFetchingUnits">
      <v-skeleton-loader type="list-item" v-for="i in 5" :key="i" />
    </div>
    <div v-else>
      <OrganisationUnitItem
        :toggledByFilter="Boolean(searchText)"
        :unit="unit"
      />
    </div>
    <BaseFooter>
      <Permissioned section="settings" class="d-flex actions-bar">
        <ArchiveUnitAction
          :unit="unit"
          permission="edit-organisation-unit.archive"
        />
        <EditParentAction
          :unit="unit"
          :parent="parent"
          permission="edit-organisation-unit.edit"
        />
      </Permissioned>
    </BaseFooter>
  </div>
</template>

<script>
import { ORGANISATION_UNITS_NAMESPACE } from "@/store/modules/organisations/organisation-units";
import { copyState } from "@/utils/helpers";
import { createNamespacedHelpers } from "vuex";
import OrganisationUnitItem from "@/views/settings/Organisation/Units/OrganisationUnitItem";
import BaseFooter from "@/components/common/BaseFooter";
import Permissioned from "@/components/common/Permissioned";
import ArchiveUnitAction from "@/views/settings/Organisation/Units/actions/ArchiveUnitAction";
import EditParentAction from "@/views/settings/Organisation/Units/actions/EditParentAction";

const { mapState } = createNamespacedHelpers(ORGANISATION_UNITS_NAMESPACE);

export default {
  components: {
    OrganisationUnitItem,
    BaseFooter,
    Permissioned,
    ArchiveUnitAction,
    EditParentAction
  },
  props: {
    searchText: String,
    unit: Object,
    parent: Object
  },
  computed: {
    ...mapState(copyState(["isFetchingUnits"]))
  }
};
</script>

<style scoped></style>
